import React, { useContext, useEffect, useState } from "react";
import { ModalContext } from "components/ModalContext";
import {getDetailedCollectionInfo, getDetailedSelectionInfo} from "utils/builder/IScheduleLogic";
import classNames from "classnames";
import "./QuickStats.scss";

import QuickStatsItem from "components/uiComponents/QuickStatsItem";
import QuickStatsModal from "components/modals/QuickStatsModal";
import {useSelector} from "react-redux";

const QuickStats = ({
  quickCounterData,
  isCompare,
  sidebarIsOpened,
}) => {
  const [details, setDetails] = useState(null);
  const { handleModal } = useContext(ModalContext);
  const { compare } = useSelector((state) => state.viewer);

  const handleCloseModal = () => {
    handleModal(null, true);
  };
  
  const handleDetails = () => {
    handleModal(
      <QuickStatsModal 
        title="Selection details"
        closeModal={handleCloseModal}
        data={details}
      />,
      false,
      true
    );
  };

  useEffect(async () => {
    let newDetails = null;

    if(isCompare) {
      newDetails = compare.selectionDetails.map((el) => { return {info: el.infoCollection, sumCategories: el.sumCategories, color:  el.color, name:  el.name}});
    } else {
      newDetails = [{ info: getDetailedSelectionInfo(), sumCategories: null, color: null, name: null}];
    }

    setDetails(newDetails);
  }, [quickCounterData, compare.selectionDetails.length]);

  return (
    <div
      className={classNames({
        "quick-stats": true,
        "quick-stats--replaced": !sidebarIsOpened,
      })}
    >
      <div className="quick-stats__wrapper">
        {quickCounterData &&
          quickCounterData.map(({ value, name, percentage, unit }) => (
            <QuickStatsItem
              value={value}
              name={name}
              percent={percentage}
              key={name + value}
              unit={unit}
            />
          )
        )}
      </div>
      
      {details?.length !== 0 &&
        <div
          className="quick-stats__details"
          onClick={handleDetails}
        >
          Selection details
        </div>
      }
    </div>
  );
};

export default QuickStats;
